const PageButtonTypeMap = {
  REFRESH: {
    icon: 'refresh-icon',
    executeFunction: 'doRefresh'
  },
  SPREAD: {
    icon: 'spread-icon',
    executeFunction: 'doSpread'
  },
  ADVANCE_SEARCH: {
    icon: 'advance-search-icon'
  },
  EXPORT: {
    icon: 'export-icon',
    executeFunction: 'doExport'
  },
  OP_SHARE: {
    icon: 'op-share-icon',
    executeFunction: 'doShare'
  }
}

export default PageButtonTypeMap
